import { AxiosInstance } from 'axios';

export type JobBulkFinanceUpdateRequestCommodity = {
  guid: string;
  payment: string;
};

export type JobBulkFinanceUpdateRequestItem = {
  jobGuid: string;
  payment: string;
  commodities?: JobBulkFinanceUpdateRequestCommodity[];
};

export type JobBulkFinanceUpdateRequest = JobBulkFinanceUpdateRequestItem[];

export class JobBulkFinanceService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  update(request: JobBulkFinanceUpdateRequest) {
    return this.instance.put('/bulk/jobs/finances', request);
  }
}
